import React from "react";

import Env from "app/core/environment";
import Resource from "app/core/resource";

class Delivery extends React.Component {
    constructor(props) {
        super(props);

        this.HTMLResource = Resource.getHTML(Env.getInstance().getLanguage());
    }

    /**
     * @private
     * @method _hasDescription
     * @param item {Object}
     * @returns {boolean}
     */
    _hasDescription(item) {
        return Boolean(item.description);
    }

    /**
     * @private
     * @method _hasAdvantages
     * @param item {Object}
     * @returns {boolean}
     */
    _hasAdvantages(item) {
        return Boolean(item.advantages?.length);
    }

    /**
     * @private
     * @method _hasSubtitle
     * @param item {Object}
     * @returns {boolean}
     */
    _hasSubtitle(item) {
        return Boolean(item.subtitle);
    }

    /**
     * @private
     * @method _renderAdvantages
     * @param item {Object}
     * @returns {React.element}
     */
    _renderAdvantages(item) {
        return (
            <ul className="item__advantages">
                {item.advantages.map((advantage, index) => (
                    <li dangerouslySetInnerHTML={{__html: advantage}} key={index} />
                ))}
            </ul>
        );
    }

    /**
     * @private
     * @method _renderServiceTypes
     * @param items {Array}
     * @returns {Array}
     */
    _renderServiceTypes(items) {
        return items.map((item, index) => (
            <div className="service-types__item item w-100" key={index}>
                <div className="item__header d-flex align-items-center">
                    <div className="item__preview d-flex align-items-center justify-content-center">
                        <img
                            src={item.preview}
                            alt="icon"
                            width={60}
                            height={60}
                        />
                    </div>

                    <div>
                        <p className="item__title f-weight-5" dangerouslySetInnerHTML={{__html: item.title}} />

                        {this._hasSubtitle(item) && (
                            <p className="item__subtitle" dangerouslySetInnerHTML={{__html: item.subtitle}} />
                        )}
                    </div>
                </div>

                <div className="item__body">
                    {this._hasDescription(item) && (
                        <p className="item__description" dangerouslySetInnerHTML={{__html: item.description}} />
                    )}

                    {this._hasAdvantages(item) && this._renderAdvantages(item)}
                </div>
            </div>
        ));
    }

    /**
     * @public
     * @method render
     * @returns {React.element}
     */
    render() {
        return (
            <div className="delivery">
                <p className="delivery__title f-weight-5">
                    { this.HTMLResource.about.delivery.deliveryTypes.title }
                </p>

                <div className="delivery__warning alert-danger">
                    <div
                        dangerouslySetInnerHTML={{__html: this.HTMLResource.about.delivery.warning.description}}
                    />
                </div>

                <div className="delivery__body">
                    <div className="delivery__service-types service-types delivery-types">
                        <div className="service-types__items">
                            { this._renderServiceTypes(this.HTMLResource.about.delivery.deliveryTypes.items) }
                        </div>
                    </div>

                    <div className="delivery__service-types service-types payment-types">
                        <p className="delivery__title f-weight-5">
                            { this.HTMLResource.about.delivery.paymentTypes.title }
                        </p>

                        <div className="service-types__items">
                            { this._renderServiceTypes(this.HTMLResource.about.delivery.paymentTypes.items) }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Delivery;
